import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const epiFn = /* @__PURE__ */ createRecipe('epi', {}, [])

const epiVariantMap = {}

const epiVariantKeys = Object.keys(epiVariantMap)

export const epi = /* @__PURE__ */ Object.assign(memo(epiFn.recipeFn), {
  __recipe__: true,
  __name__: 'epi',
  __getCompoundVariantCss__: epiFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: epiVariantKeys,
  variantMap: epiVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, epiVariantKeys)
  },
  getVariantProps: epiFn.getVariantProps,
})